import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import api from 'apis/api';

import { useEntityStore } from 'store/index';

export type Workspace = {
  id: string;
  name: string;
  email_domain: string;
} | null;

interface WorkspaceState {
  currentWorkspaceId: string;
  workspace: Workspace;
  options: Workspace[];
  setWorkspace: (workspace: Workspace) => void;
  getAllWorkspaces: () => Promise<Workspace[]>;
}

const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set) => ({
      currentWorkspaceId: '',
      workspace: null,
      options: [],
      setWorkspace: (workspace) => {
        set({ workspace, currentWorkspaceId: workspace?.id ?? '' });

        useEntityStore.setState({
          entities: null,
          selectedEntity: null,
          consolidationSets: null,
        });
      },
      getAllWorkspaces: async () => {
        const { data } = await api.get('/api/v2/org-management/organisations');
        return data?.message?.sort((a: Workspace, b: Workspace) =>
          a?.name?.localeCompare(b?.name ?? '')
        );
      },
    }),
    {
      name: 'workspace-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        workspace: state.workspace,
        currentWorkspaceId: state.currentWorkspaceId,
        options: state.options,
      }),
    }
  )
);

export { useWorkspaceStore };
